import React, { useState } from 'react';
import { MenuItem, Typography, Menu } from '@mui/material';
import { IQrEntry } from './constants';
import { ConfirmDeleteModal } from '../embeds/embedsV2/ConfirmDelete';
import { MenuIcon } from '../../../components/MenuOptions/MenuIcon';
import {
  IconPencil,
  IconInActive,
  IconCheck,
  IconTrash,
} from '../../../utils/icons';

interface Props {
  entry: IQrEntry;
  isDetailedPage?: boolean;
  onClose?: () => void;
  onEdit?: () => void;
  onDeactivate?: () => void;
  onActivate?: () => void;
  onDelete?: () => void;
}

export function QrEntryMenu({
  entry,
  isDetailedPage,
  onClose,
  onEdit,
  onDeactivate,
  onActivate,
  onDelete,
}: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const onMenuClose = () => {
    setAnchorEl(null);
    onClose?.();
  };

  const getMenuOption = (Icon: any, text: string, callback?: any) => {
    if (!callback) return null;

    return (
      <MenuItem
        className="!p-3 !px-4 flex gap-2 items-center min-w-[200px]"
        onClick={() => {
          callback();
          onMenuClose();
        }}
      >
        <Icon width={24} height={24} size={24} stroke="#B0B0B0" />
        <Typography color="text.secondary">
          {text}
        </Typography>
      </MenuItem>
    );
  };

  const menuId = `menu-box-${entry || Math.random()}`;
  return (
    <>
      <div onClick={(e) => e.stopPropagation()}>
        <MenuIcon
          isDetailedPage={isDetailedPage}
          id={menuId}
          element={anchorEl}
          onClick={setAnchorEl}
        />
        <Menu
          anchorEl={anchorEl}
          onClose={onMenuClose}
          id="single-video-menu"
          aria-labelledby={menuId}
          open={!!anchorEl}
          className="py-2"
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          {getMenuOption(IconPencil, 'Edit', onEdit)}
          {!entry.deactivated &&
            getMenuOption(IconInActive, 'Deactivate', onDeactivate)}
          {entry.deactivated &&
            getMenuOption(IconCheck, 'Activate', onActivate)}
          {getMenuOption(IconTrash, 'Delete', onDelete)}
        </Menu>
      </div>
      <ConfirmDeleteModal
        show={showDeleteModal}
        onCancel={() => setShowDeleteModal(false)}
        onOkay={onDelete}
      />
    </>
  );
}
